/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VolumeIndicator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function VolumeIndicator({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Recording/VolumeIndicator"
  
}) {
let recorderDeviceVolumeValueData = fromData.useDataFormat({ viewPath,
context: 'recorder',
path: 'deviceVolume',
format: fromFormat.percentage,
})
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
  return (<React.Fragment
>
<div
  data-testid="VolumeIndicator.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="VolumeIndicator.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-1-1GPqMB': typeof recorderDeviceVolumeValueData === 'number' ? `${recorderDeviceVolumeValueData}px` : recorderDeviceVolumeValueData,'--bc-2-1GPqMB': dtColorsGreen200}}
 className={`views-block ${styles.Vertical1}`}
/>
</div>
{children}
</React.Fragment>)
}